export const generateUUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

export const debounce = function (func, wait, immediate) {
  let timeout, args, context, timestamp, result
  let later = function () {
    let last = new Date() - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = new Date()
    var callNow = immediate && !timeout
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const throttle = function (func, wait, options) {
  let context, args, result
  let timeout = null
  let previous = 0
  if (!options) options = {}
  let later = function () {
    previous = options.leading === false ? 0 : new Date()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    let now = new Date()
    if (!previous && options.leading === false) previous = now
    let remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

// 存储数据并设置过期时间
export const setStorageWithExpiry = function (key, value, ttl) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  };
  sessionStorage.setItem(key, JSON.stringify(item));
  // 设置定时器检查过期
  const timeout = ttl - (now.getTime() % ttl);
  setTimeout(() => {
    clearExpiredStorage(key);
  }, timeout);
}

// 获取数据，如果过期则自动清除
export const getStorageWithExpiry = function (key) {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    // 数据已过期，清除它
    sessionStorage.removeItem(key);
    return null;
  }

  return item.value;
}

// 清除已过期的数据
export const clearExpiredStorage = function (key) {
  const itemStr = sessionStorage.getItem(key);
  if (itemStr) {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key);
    }
  }
}

/**
 * 增加vConsole调试控件
 */
export const vConsoleWidget = () => {
  var consoleWidget = document.getElementById('v-console-widget')
  if (!consoleWidget) {
    const Script = document.createElement('script')
    Script.id = 'v-console-widget'
    Script.src = 'https://cdn.staticfile.org/vConsole/3.14.6/vconsole.min.js'
    document.head.appendChild(Script)
    Script.addEventListener('load', (ev) => {
      window.VConsole && new window.VConsole()
    })
  }
}
